import React from 'react';
import './doc-sheet-close-btn.css';

/** Shared X control for doc-sheet chrome and mission full view. */
export const DocSheetCloseButton = ({ onClose }) => {
  if (!onClose) return null;
  return (
    <button
      type="button"
      className="doc-sheet__close-btn"
      onClick={onClose}
      title="Close (Esc)"
      aria-label="Close"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  );
};
